import React, { forwardRef } from 'react'

import './Button.scss'

interface IButtonProps{
    variant: 'filled' | 'outlined' | 'hollow' | 'disabled',
    children?: string,
    action?: CallableFunction,
    frontIcon?: React.ReactNode,
    backwardIcon?: React.ReactNode
    type?: "button" | "submit" | "reset"
}

const Button = forwardRef<HTMLButtonElement, IButtonProps>(({variant, type, children, action, frontIcon, backwardIcon}: IButtonProps, ref) => {
  return (
    <button ref={ref} type={type} onClick={() => {if(!!action) action()}} className={'btn ' + variant}><span>{frontIcon}{children}{backwardIcon}</span></button>
  )
})

export default Button